module.exports = __webpack_public_path__ + "static/media/light-cross-icon.8eca8299.svg";